var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style['main']},[_c('keep-alive',{attrs:{"include":[..._setup.memoArr]}},[_c('router-view',{key:_setup.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }